//(function () {
//	'use strict';
	
//	const module = angular.module('imApp');
	
//	module.component('cuttingPlans', {
//		templateUrl: 'views/components/views/cuttingPlans/cuttingPlans.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'cuttingPlansService', 'modalService', 'translateService', 'paymentPlansService', 'ttGridFactory', function (stateService, utilityService, cuttingPlansService, modalService, translateService, paymentPlansService, ttGridFactory) {
			
//			// #region VARIABLES & DEFINITIONS
			
//            const vm = this;

//            let translations = {
//                error: '',
//                ok: '',
//                tt_delete_grid_row_title: '',
//                tt_delete_grid_row_warning: '',
//                tt_delete_grid_row_confirm: '',
//                tt_delete_grid_row_abort: '',

//            };

//			vm.model = {
//				setting: {},
//				selectListStatuses: [],
//				gridReady: false
//			};

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_cuttingplans_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setSpecialFunc({
//                    buttons: [{
//                        name: 'customDelete',
//                        icon: 'far-trash-alt',
//                        btn_type: 'danger',
//                        tooltip: 'delete_row',
//                        translateTooltip: true,
//                        func: (data) => {
//                            modalService.show({
//                                type: 'warning',
//                                title: translations.tt_delete_grid_row_title,
//                                message: translations.tt_delete_grid_row_warning,
//                                buttons: [{
//                                    label: translations.tt_delete_grid_row_abort,
//                                    cssClass: 'btn-warning',
//                                    action: function (dialogItself) {
//                                        dialogItself.close();
//                                    }
//                                }, {
//                                    label: translations.tt_delete_grid_row_confirm,
//                                    cssClass: 'btn-danger',
//                                    action: async function (dialogItself) {
//                                        await vm.grid.gridfunc.removeRow(data);
//                                        vm.grid.gridfunc.saveChanges(false);
//                                        dialogItself.close();
//                                    }
//                                }]
//                            });
//                        }
//                    }]
//                })
//                .setCustomToolbarButtons([{
//                    name: 'cuttingplans_new',
//                    text: 'cuttingplans_new',
//                    func: () => {
//                        paymentPlansService.getNextNumber({ table_name: 'cuttingplan' }).then(function (response) {
//                            stateService.go('cuttingplan', { cuttingplan_keyno: response[0].nextnumber });
//                        });
//                    },
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);

//			// #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await cuttingPlansService.getCuttingPlans())[0];
//            }

//            async function loadStatuses() {
//                vm.model.selectListStatuses = await cuttingPlansService.listStatuses();
//            }
			
//			// #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2884,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'cuttingplanstatus_no':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.cuttingplanstatus_no) !== true) return;

//                        vm.model.setting.cuttingplanstatus_no = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.cuttingplanstatus_no, true) !== true) return;

//                        loadGrid();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                await loadSetting();
//                loadStatuses();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
